module.exports = __webpack_public_path__ + "img/funnel_type_radio_logo_1.19229532.svg";